import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { isAuthenticated, hasPermission } from '../utils/helpers';

const ProtectedRoute = ({ children, requiredRole = null, fallback = '/login' }) => {
  // Kiểm tra xem user đã đăng nhập chưa
  if (!isAuthenticated()) {
    return <Navigate to={fallback} replace />;
  }

  // Kiểm tra quyền truy cập nếu có yêu cầu
  if (requiredRole && !hasPermission(requiredRole)) {
    return (
      <div style={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 16
      }}>
        <h3>Không có quyền truy cập</h3>
        <p>Bạn không có quyền truy cập vào trang này.</p>
      </div>
    );
  }

  return children;
};

// Component Loading
export const PageLoading = () => {
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Spin size="large" />
    </div>
  );
};

export default ProtectedRoute;
